/* Varenne 2.0 */
(function () {
  'use strict';

  var V = window.Varenne || { routes: {}, cartType: 'page' };
  var doc = document;
  var root = doc.documentElement;
  var body = doc.body;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function rootUrl(path) {
    var r = (V.routes.root || '/').replace(/\/$/, '');
    return r + path;
  }

  /* ------------------------------------------------------------------ header */
  var header = qs('[data-header]');
  var hovering = false;
  function setHeaderHeight() {
    if (!header) return;
    root.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  function updateHeader() {
    if (!header) return;
    var solid = window.scrollY > 10 || hovering || header.contains(doc.activeElement);
    header.classList.toggle('is-solid', solid);
  }
  if (header) {
    if (header.classList.contains('site-header--transparent')) {
      body.classList.add('has-transparent-header');
      header.addEventListener('mouseenter', function () { hovering = true; updateHeader(); });
      header.addEventListener('mouseleave', function () { hovering = false; updateHeader(); });
      header.addEventListener('focusin', updateHeader);
      header.addEventListener('focusout', function () { setTimeout(updateHeader, 0); });
    }
    setHeaderHeight();
    updateHeader();
    window.addEventListener('resize', setHeaderHeight);
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  /* --------------------------------------------------------- announcement bar */
  qsa('[data-announcement]').forEach(function (bar) {
    var msgs = qsa('[data-announcement-message]', bar);
    if (msgs.length < 2) return;
    var i = 0;
    function show(n) {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    var prev = qs('[data-announcement-prev]', bar);
    var next = qs('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    if (!reduceMotion) setInterval(function () { if (!bar.matches(':hover')) show(i + 1); }, 5000);
  });

  /* ------------------------------------------------------------------ drawers */
  var overlay = qs('[data-overlay]');
  var openEl = null;
  var lastFocus = null;

  function openDrawer(id) {
    var d = doc.getElementById(id);
    if (!d) return false;
    if (openEl && openEl !== d) closeDrawer(true);
    lastFocus = doc.activeElement;
    d.hidden = false;
    if (overlay) overlay.hidden = false;
    // force reflow so the transition runs
    void d.offsetWidth;
    d.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    body.classList.add('no-scroll');
    openEl = d;
    qsa('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusTarget = qs('[data-autofocus]', d) || qs('[data-drawer-close]', d);
    setTimeout(function () { if (focusTarget) focusTarget.focus(); }, 60);
    return true;
  }

  function closeDrawer(instant) {
    var d = openEl;
    if (!d) return;
    openEl = null;
    d.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    body.classList.remove('no-scroll');
    qsa('[data-drawer-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var finish = function () {
      if (!d.classList.contains('is-open')) d.hidden = true;
      if (overlay && !openEl) overlay.hidden = true;
    };
    if (instant === true || reduceMotion) finish(); else setTimeout(finish, 420);
    if (instant !== true && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  doc.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && V.cartType !== 'drawer') return;
      if (openDrawer(id)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-overlay]')) {
      e.preventDefault();
      closeDrawer();
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openEl) closeDrawer();
  });

  /* --------------------------------------------------------- auto-submit etc */
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-autosubmit]') && t.form) t.form.submit();
    if (t.matches && t.matches('[data-sort-select]')) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', t.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });

  /* ------------------------------------------------------------------- reveal */
  var revealObserver = null;
  if (body.classList.contains('has-reveal') && 'IntersectionObserver' in window && !reduceMotion) {
    root.classList.add('reveal-ready');
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-revealed');
          revealObserver.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
  }
  function observeReveal(scope) {
    if (!revealObserver) return;
    qsa('[data-reveal]:not(.is-revealed)', scope).forEach(function (el) { revealObserver.observe(el); });
  }
  observeReveal(doc);

  /* ---------------------------------------------------------------- slideshow */
  qsa('[data-slideshow]').forEach(function (ss) {
    var slides = qsa('[data-slide]', ss);
    if (slides.length < 2) return;
    var dots = qsa('[data-slide-dot]', ss);
    var i = 0;
    var timer = null;
    var speed = (parseInt(ss.getAttribute('data-speed'), 10) || 6) * 1000;
    var auto = ss.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    function go(n) {
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      slides[i].inert = true;
      if (dots[i]) dots[i].setAttribute('aria-current', 'false');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      slides[i].inert = false;
      if (dots[i]) dots[i].setAttribute('aria-current', 'true');
      var v = qs('video', slides[i]);
      if (v && v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() { if (!auto) return; stop(); timer = setInterval(function () { go(i + 1); }, speed); }
    slides.forEach(function (s, n) { if (n !== 0) { s.setAttribute('aria-hidden', 'true'); s.inert = true; } });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    var prev = qs('[data-slide-prev]', ss);
    var next = qs('[data-slide-next]', ss);
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    ss.addEventListener('mouseenter', stop);
    ss.addEventListener('mouseleave', start);
    ss.addEventListener('focusin', stop);
    var x0 = null;
    ss.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    ss.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); start(); }
      x0 = null;
    });
    start();
  });

  /* --------------------------------------------------------------------- tabs */
  qsa('[data-tabs]').forEach(function (wrap) {
    var tabs = qsa('[role="tab"]', wrap);
    var panels = qsa('[role="tabpanel"]', wrap);
    tabs.forEach(function (tab, n) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t, m) {
          t.setAttribute('aria-selected', m === n ? 'true' : 'false');
          t.tabIndex = m === n ? 0 : -1;
          if (panels[m]) panels[m].hidden = m !== n;
        });
        observeReveal(panels[n]);
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var k = (n + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[k].click();
        tabs[k].focus();
      });
    });
  });

  /* --------------------------------------------------------------------- cart */
  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.hidden = count < 1;
      var n = qs('span', el);
      if (n) n.textContent = count;
    });
  }

  function refreshCart(open) {
    return fetch(rootUrl('/?section_id=cart-drawer'), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('CartDrawerInner');
        var current = doc.getElementById('CartDrawerInner');
        if (fresh && current) {
          current.replaceWith(fresh);
          updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
        }
        if (open) openDrawer('CartDrawer');
      });
  }

  function addToCart(form, button) {
    var fd = new FormData(form);
    var keys = [];
    fd.forEach(function (v, k) { if (k.indexOf('option-') === 0) keys.push(k); });
    keys.forEach(function (k) { fd.delete(k); });
    var errorEl = qs('[data-form-error]', form.closest('[data-product]') || form);
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    return fetch(V.routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && (res.json.description || res.json.message)) || 'This item could not be added to your bag.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          return null;
        }
        return refreshCart(true);
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = 'Something went wrong. Please try again.'; errorEl.hidden = false; }
      })
      .then(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); }
      });
  }

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ajax-add]')) return;
    if (V.cartType !== 'drawer' || !doc.getElementById('CartDrawer') || !window.fetch) return;
    e.preventDefault();
    var button = e.submitter || qs('[type="submit"]', form);
    if (button && button.disabled) return;
    addToCart(form, button);
  });

  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cart-change]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    fetch(V.routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) })
    })
      .then(function () { return refreshCart(false); })
      .then(function () {
        var c = qs('#CartDrawer [data-drawer-close]');
        if (c) c.focus();
      });
  });

  /* quantity steppers */
  doc.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty-step]');
    if (!s) return;
    var input = qs('input[type="number"]', s.parentElement);
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var val = (parseInt(input.value, 10) || min) + parseInt(s.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, val);
  });

  /* ------------------------------------------------------------- product page */
  qsa('[data-product]').forEach(function (section) {
    var variants = [];
    var dataEl = qs('[data-variants]', section);
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; } }
    var form = qs('[data-product-form]', section);
    var idInput = qs('[data-variant-id]', section);
    var priceEls = qsa('[data-price]', section);
    var compareEl = qs('[data-compare]', section);
    var buttons = qsa('[data-add-button]', section);
    var mainButton = qs('[data-add-button]:not([data-sticky-add])', section);
    var fieldsets = qsa('[data-option-index]', section);
    var track = qs('[data-gallery-track]', section);
    var navs = qsa('[data-gallery-target]', section);

    function goToMedia(id, smooth) {
      if (!track || !id) return;
      var slide = qs('[data-media-id="' + id + '"]', track);
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      setActive(id);
    }
    function setActive(id) {
      navs.forEach(function (n) {
        var on = n.getAttribute('data-gallery-target') === String(id);
        n.classList.toggle('is-active', on);
        n.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    navs.forEach(function (n) {
      n.addEventListener('click', function () { goToMedia(n.getAttribute('data-gallery-target'), true); });
    });
    if (track && 'IntersectionObserver' in window) {
      var gio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) setActive(en.target.getAttribute('data-media-id'));
        });
      }, { root: track, threshold: 0.6 });
      qsa('[data-media-id]', track).forEach(function (s) { gio.observe(s); });
    }
    function step(dir) { if (track) track.scrollBy({ left: dir * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' }); }
    var prev = qs('[data-gallery-prev]', section);
    var next = qs('[data-gallery-next]', section);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    goToMedia(section.getAttribute('data-initial-media'), false);

    function selected() {
      return fieldsets.map(function (fs) {
        var c = qs('input[type="radio"]:checked', fs);
        return c ? c.value : null;
      });
    }
    function setButtons(enabled, label) {
      buttons.forEach(function (b) {
        b.disabled = !enabled;
        var l = qs('[data-add-label]', b) || b;
        l.textContent = label;
      });
    }
    function update(fromUser) {
      var sel = selected();
      fieldsets.forEach(function (fs, i) {
        var l = qs('[data-option-label]', fs);
        if (l && sel[i]) l.textContent = sel[i];
        qsa('input[type="radio"]', fs).forEach(function (inp) {
          var test = sel.slice();
          test[i] = inp.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return o === test[k]; });
          });
          var lab = qs('label[for="' + inp.id + '"]', fs);
          if (lab) lab.classList.toggle('is-unavailable', !ok);
        });
      });
      var match = null;
      variants.forEach(function (v) {
        if (!match && v.options.every(function (o, k) { return o === sel[k]; })) match = v;
      });
      if (!match) { setButtons(false, 'Unavailable'); return; }
      if (idInput) idInput.value = match.id;
      priceEls.forEach(function (p) { p.textContent = match.price; });
      if (compareEl) { compareEl.textContent = match.compare || ''; compareEl.hidden = !match.compare; }
      setButtons(match.available, match.available ? 'Add to bag' : 'Sold out');
      if (fromUser) {
        if (match.media) goToMedia(match.media, true);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
    if (fieldsets.length) update(false);

    var sticky = qs('[data-sticky-atc]', section);
    var stickyBtn = qs('[data-sticky-add]', section);
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(mainButton);
    }
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(mainButton || undefined);
        else if (mainButton) mainButton.click();
      });
    }
  });

  /* ---------------------------------------------------------- recommendations */
  qsa('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || qs('.card', el) || !window.fetch) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recommendations]', parsed);
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          observeReveal(el);
        }
      })
      .catch(function () {});
  });

  /* -------------------------------------------------------- predictive search */
  var pInput = qs('[data-predictive-input]');
  var pResults = qs('[data-predictive-results]');
  var pTimer = null;
  if (pInput && pResults && window.fetch) {
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; return; }
      pTimer = setTimeout(function () {
        var url = V.routes.predictive + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=8&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var sec = parsed.getElementById('shopify-section-predictive-search');
            pResults.innerHTML = sec ? sec.innerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* -------------------------------------------------------------------- popup */
  qsa('[data-popup]').forEach(function (p) {
    var key = 'varenne-popup-dismissed';
    var seen = false;
    try { seen = window.localStorage.getItem(key) === '1'; } catch (err) { seen = false; }
    if (seen && p.getAttribute('data-force') !== 'true') return;
    var delay = (parseInt(p.getAttribute('data-delay'), 10) || 0) * 1000;
    setTimeout(function () {
      p.hidden = false;
      void p.offsetWidth;
      p.classList.add('is-open');
    }, delay);
    qsa('[data-popup-close]', p).forEach(function (b) {
      b.addEventListener('click', function () {
        p.classList.remove('is-open');
        setTimeout(function () { p.hidden = true; }, 400);
        try { window.localStorage.setItem(key, '1'); } catch (err) { /* storage unavailable */ }
      });
    });
  });
})();
